import { useTranslate } from '@i18n';
import { useCategories } from '@queries';
import { ToolPanel, typography, ToggleButton } from '@ui';

import * as css from './CustomModuleEditor.css';

export const BodyPartsFilter = ({ filter, onSelect }: { filter: string[]; onSelect: (bodyPartId: string) => void }) => {
    const { data: categories = [] } = useCategories('body_part');
    const t = useTranslate();

    return (
        <aside className={css.aside}>
            <ToolPanel title="Filter">
                <div className={css.filterGroup}>
                    <h4 className={typography({ variant: 'h4' })}>Body Parts</h4>
                    {categories.map((category) => {
                        const title = t(category.i18n ?? '-');
                        return (
                            <ToggleButton
                                key={category.id}
                                icon="chart-line"
                                maxLetters={36}
                                isActive={filter.includes(category.id)}
                                onChange={() => onSelect(category.id)}
                            >
                                {title}
                            </ToggleButton>
                        );
                    })}
                </div>
            </ToolPanel>
        </aside>
    );
};
